import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  professionalProjects,
  academicProjects,
} from '../../src/componenets/constants';
import parse from 'html-react-parser';

export default function ProjectsSection() {
  const [activeTab, setActiveTab] = useState('professional');
  const [expandedIndex, setExpandedIndex] = useState(null);

  const displayedProjects =
    activeTab === 'professional' ? professionalProjects : academicProjects;

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section id="experience" className="pt-20 pb-10 px-4">
      <div className="mx-auto max-w-7xl">
        <h2 className="text-4xl font-bold mb-10 text-center text-black dark:text-white">
          Experience
        </h2>

        {/* Optional Tabs */}
        {/* <div className="flex justify-center mb-8 space-x-4">
          {["professional", "academic"].map((tab) => (
            <button
              key={tab}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                activeTab === tab
                  ? "bg-primary text-white"
                  : "bg-gray-200 text-gray-800 hover:bg-primary hover:text-white dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-primary"
              }`}
              onClick={() => {
                setActiveTab(tab);
                setExpandedIndex(null);
              }}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div> */}

        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.4 }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {displayedProjects.map((project, index) => {
              const isExpanded = expandedIndex === index;

              return (
                <motion.div
                  key={index}
                  layout
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="cursor-pointer p-6 rounded-2xl border border-primary/30 dark:border-primary/50 shadow-md hover:shadow-lg bg-white/80 dark:bg-neutral-900/80 backdrop-blur-sm transition-all"
                  onClick={() => handleToggle(index)}
                >
                  <h4 className="text-xl font-semibold mb-1 text-gray-900 dark:text-white">
                    {project.title}
                  </h4>
                  <p className="text-sm mb-1 text-gray-700 dark:text-gray-300 font-medium">
                    {project.compnay}
                  </p>

                  {project.location && (
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                      <strong>Location:</strong> {project.location}
                    </p>
                  )}
                  {project.timeline && (
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                      <strong>Timeline:</strong> {project.timeline}
                    </p>
                  )}

                  <p className="text-sm mt-2 text-gray-800 dark:text-gray-200">
                    {project.description}
                  </p>

                  <p className="text-xs italic mt-2 text-primary">
                    Tech: {project.tech}
                  </p>

                  <AnimatePresence>
                    {isExpanded && (
                      <motion.div
                        key="expanded"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                        className="overflow-hidden text-sm mt-3 text-gray-700 dark:text-gray-300 space-y-1"
                      >
                        {project.fullDescription && (
                          <p>
                            <strong className="text-gray-800 dark:text-white">
                              More:
                            </strong>{' '}
                            {parse(project.fullDescription)}
                          </p>
                        )}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              );
            })}
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
}
